import { colors } from "components/Theme/WebTheme.js";
import { container, primaryColor } from "./material-kit-react.js";

const bottomFooterStyle = {
  block: {
    color: "inherit",
    padding: "10px",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block",
  },
  left: {
    float: "left!important",
    display: "block",
  },
  right: {
    margin: "0",
    float: "right!important",
  },
  footer: {
    padding: "0px",
    textAlign: "center",
    position: "fixed",
    width: "100%",
    bottom: 0,
    zIndex: "2",
  },
  a: {
    color: primaryColor,
    textDecoration: "none",
    backgroundColor: "transparent",
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: colors.WHITE,
    },
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0",
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto",
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px",
  },
  footerSocialIcons: {
    position: "relative",
    fontSize: "20px !important",
    marginRight: "4px",
    color: "white",
  },
};
export default bottomFooterStyle;
